import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Currencies, CurrencyConverterService } from 'src/app/services/currency-converter.service';

@Component({
  selector: 'app-currency-converter',
  templateUrl: './currency-converter.component.html',
  styleUrls: ['./currency-converter.component.css']
})
export class CurrencyConverterComponent implements OnInit {

  currencies$: Observable<Currencies>;
  constructor(private currs: CurrencyConverterService) { }

  ngOnInit(): void {
    console.log('currency service started');
    // this.currencies$ = this.currs.fetchCurrencies();

    this.currencies$ = this.currs.currencies$;
  }


}
